import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { Image } from 'primereact/image';
import logoImg from '../../../assets/images/logo.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const StipendReportTemplate = (props) => {

    const { reportId = '', schoolOrDeptName = '', requestDate = '', status = '', purpose = '', reportInformation = [], fundingDetails = [], specifyPurpose = '' } = props;


    return (
        <div>
            <div className="border m-4">
                <div className='text-center py-8'>
                    <Link to={""}><Image src={logoImg} width={"104"} height={"105"} imageClassName='m-auto' /></Link>
                    <div>
                        <div className="font-bold text-lg">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                        <div className="font-semibold text-base">Preparing our students for their future</div>
                        <div className="font-light text-sm">
                            <div>Office of the Chief Human Resources & Operations Officer</div>
                            <div>223 North Jackson St. Glendale, California 91206-4380</div>
                            <div>Telephone:818-241-3111,Ext.1256 Fax:818-547-3207</div>
                        </div>
                    </div>
                    <div className="my-4 font-bold text-xl underline">
                        Official Stipend Form
                    </div>
                </div>

                <div className='pt-3 mx-12'>
                    <div className="font-normal">SCHOOL NAME : _______________________</div>
                    <div className="flex">
                        <div className="font-normal">SCHOOL YEAR : _______________________</div>
                        <div className="font-normal">SEMESTER : _______________________</div>
                    </div>
                    <div className="font-medium">STIPEND TYPE :</div>
                    <div className="border text-base pl-4">
                        <div>
                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                            <label for="vehicle1"> Elementary - Extra - Curriculum Stipend  (0100000101110111101)</label>
                        </div>

                        <div>
                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                            <label for="vehicle1"> Middle School - Extra - Curriculum Stipend  (0100000101110111101)</label>
                        </div>

                        <div>
                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                            <label for="vehicle1"> High School - Extra - Curriculum Stipend  (0100000101110111101)</label>
                        </div>

                        <div>
                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                            <label for="vehicle1"> Head Counselor Stipend  (0100000101110111101)</label>
                        </div>

                    </div>
                    <div className="flex">
                        <div className="font-normal">EMPLOYEE'S NAME : _______________________</div>
                        <div className="font-normal">EMPLOYEE'S ID : _______________________</div>
                    </div>

                    <div className="mt-4">
                        <div className="flex">
                            <div className="font-normal">ASSIGNMENT # 1 : _______________________</div>
                            <div className="font-normal">AMOUNT : _______________________</div>
                        </div>
                        <div className="flex">
                            <div className="font-normal">ASSIGNMENT # 2 : _______________________</div>
                            <div className="font-normal">AMOUNT : _______________________</div>
                        </div>
                        <div className="flex">
                            <div className="font-normal">ASSIGNMENT # 3 : _______________________</div>
                            <div className="font-normal">AMOUNT : _______________________</div>
                        </div>
                        <div className="flex">
                            <div className="font-normal">ASSIGNMENT # 4 : _______________________</div>
                            <div className="font-normal">AMOUNT : _______________________</div>
                        </div>
                    </div>


                    <div className="mt-4">
                        <div className="flex">
                            <div className="font-normal">EMPLOYEE SIGNATURE : _______________________</div>
                            <div className="font-normal">DATE : _______________________</div>
                        </div>
                        <div>Employee's signature indicates that the employee is aware of and understands the Board Policies and Salary Regulations governing Extra - Curricular Assignments and agrees to perform such duties as designed.</div>

                    </div>

                    <div className="mt-4">
                        <div className="flex">
                            <div className="font-normal">PRINCIPLE SIGNATURE : _______________________</div>
                            <div className="font-normal">DATE : _______________________</div>
                        </div>
                        <div>To be signed by principle prior to beginning of assignment:I certify that the above employees are eligible to be elected for extra - curricular assignments. </div>

                    </div>

                    <div className="mt-4">
                        <div>EXECUTIVE</div>

                        <div className="flex">
                            <div className="font-normal">MANAGEMENT SIGNATURE : _______________________</div>
                            <div className="font-normal">DATE : _______________________</div>
                        </div>
                    </div>

                    <div className="mt-4">
                        <div className="flex">
                            <div className="font-normal">PRINCIPLE SIGNATURE : _______________________</div>
                            <div className="font-normal">DATE : _______________________</div>
                        </div>
                        <div>To be signed by principle upon completion of assignment : I certify that the above employees have completed their assignments and are eligible for extra - curricular payments. </div>

                    </div>

                    <div className="mt-4">
                        <div className="flex">
                            <div className="font-bold">SUBMITTED BY : _______________________</div>
                            <div className="font-normal">DATE : _______________________</div>
                        </div>
                        <div>* More than one stipend assignment may be included on the same form if an employee is fulfilling multiple assignments at one site. </div>

                    </div>





                    <div className="mt-4">
                        <div>
                            <h1 class="text-1xl font-bold underline">
                                ELEMENTARY EXTRA-CURRICULAR STIPENDS
                            </h1>

                            <div className="capitalize">
                                For approved categories, please see the CBA Appendix E, Assignment
                                12a.{" "}
                                <span className="font-bold">
                                    At the elementary level, up to six (6) stipends per semester were
                                    approved per school.
                                </span>
                                This form will designate the employee to which you wish the stipend
                                to be paid. It is also possible to split the stipend equally between
                                two teachers, should you wish to do so for such activities as Math
                                Field Day and or Spelling Bee, etc. While it is not required that
                                you use the stipend each "semester (1/2 year), it is available
                                <br />
                                <br />
                                In addition, a Choral Director stipend is available per CBA Appendix
                                E. Assignment 2.
                            </div>
                        </div>

                        <br />
                        <br />
                        <div>
                            <h1 class="text-1xl font-bold underline">
                                MIDDLE SCHOOL EXTRA-CURRICULAR STIPENDS
                            </h1>

                            <div className="capitalize">
                                For approved stipends, please see CBA Appendix E, Assignments 1-14
                                and Appendix N. Head Counselor.{" "}
                                <span className="font-bold">
                                    At the middle school level, up to six (6) stipends per semester
                                    were approved per school for Assignment 12b.
                                </span>{" "}
                                This form will designate the employee to which you wish the stipend
                                to be paid. It is also possible to split the stipend equally between
                                two teachers, should you wish to do so. While it is not required
                                that you use the stipend each semester, it is available.
                            </div>
                        </div>

                        <br />
                        <br />
                        <div>
                            <h1 class="text-1xl font-bold underline">
                                HIGH SCHOOL EXTRA-CURRICULAR STIPENDS
                            </h1>

                            <div className="capitalize">
                                For approved stipends, please see CBA Appendix E, Assignments 1-14
                                and Appendix N, Head Counselor.{" "}
                                <span className="font-bold">
                                    At the high school level, up to eight (8) stipends per semester
                                    were approved per school for Assignment 12b.
                                </span>{" "}
                                This form will designate the employee to which you wish the stipend
                                to be paid. It is also possible to split the stipend equally between
                                two teachers, should you wish to do so. While it is not required
                                that you use the stipend each semester, it is available.
                            </div>
                        </div>
                        <br />
                        <br />
                        <div>
                            <h1 class="text-1xl font-bold underline">
                                SECONDARY DEPARTMENT CHAIR STIPENDS{" "}
                            </h1>

                            <div className="capitalize">
                                For approved Department Chairperson stipends, please see CBA
                                Appendix E, Assignments 15. This form will designate the employee to
                                which you wish the stipend to be paid. It is also possible to split
                                the stipend equally between two teachers, should you wish to do so.
                                While it is not required that you use the stipend each semester, it
                                is available. Department stipends available include:
                            </div>
                        </div>
                        <br />
                        <div className="flex gap-72">
                            <div>
                                <ul className="list-disc space-y-2 space-x-4">
                                    <li className="ml-[15px]">Art</li>
                                    <li>Business Education</li>
                                    <li>English</li>
                                    <li>ELD</li>
                                    <li>Foreign Language</li>
                                    <li>Health & Guidance</li>
                                    <li>Home Economics</li>
                                    <li>Industrial Arts</li>
                                </ul>
                            </div>

                            <div>
                                <ul className="list-disc space-y-2">
                                    <li>Math</li>
                                    <li>Music</li>
                                    <li>PE</li>
                                    <li>Reading</li>
                                    <li>Science</li>
                                    <li>Social Studies</li>
                                    <li>Special Education</li>
                                    <li>VAPA</li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default StipendReportTemplate